export default __webpack_public_path__ + "static/media/close-chevron.1b00d916.svg";